// Admin API endpoints (superadmin only)

import { apiClient } from './client';
import type {
  ListUsersResponse,
  ApproveUserResponse,
  AdminAccountDetailResponse,
  CreditAccountResponse,
  SecurityMasterSyncResponse,
  UserStatusFilter,
} from '../types/admin';

/**
 * Admin API functions (requires superadmin privileges)
 */
export const adminApi = {
  /**
   * List all users with optional status filter
   */
  listUsers: (status: UserStatusFilter = 'all'): Promise<ListUsersResponse> => {
    return apiClient.get<ListUsersResponse>(`/api/admin/users?status=${status}`);
  },

  /**
   * Approve a pending user
   */
  approveUser: (userId: string): Promise<ApproveUserResponse> => {
    return apiClient.post<ApproveUserResponse>(`/api/admin/users/${userId}/approve`);
  },

  /**
   * Get admin account details with positions and balance changes
   */
  getAccount: (accountId: string): Promise<AdminAccountDetailResponse> => {
    return apiClient.get<AdminAccountDetailResponse>(`/api/admin/accounts/${accountId}`);
  },

  /**
   * Credit an account with cash
   */
  creditAccount: (accountId: string, amount: string, description?: string): Promise<CreditAccountResponse> => {
    return apiClient.post<CreditAccountResponse>(`/api/admin/accounts/${accountId}/credit`, {
      amount,
      description: description || null,
    });
  },

  /**
   * Trigger a full security master sync from RQD
   */
  syncSecurityMaster: (): Promise<SecurityMasterSyncResponse> => {
    return apiClient.post<SecurityMasterSyncResponse>('/api/admin/security-master/sync');
  },
};
